import BackgroundCheckManualReviewAlert from './BackgroundCheckManualReviewAlert';
export default BackgroundCheckManualReviewAlert;
